export default __webpack_public_path__ + "static/profilepic-7f1750bbd0d544e941111974889044e9.jpg";